module.exports = __webpack_public_path__ + "img/icon_benefit3@3x.5426857c.png";